export default {
    noCustomer: 'У данного проекта отсутствуют заказчик',
    noContractor: 'У данного проекта отсутствуют генподрядчик',
};
